var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus128030(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-128-030-1{fill:#fff;}.cls-128-030-2,.cls-128-030-3{fill:none;}.cls-128-030-2{opacity:0.2;}.cls-128-030-3{stroke:#6e6e6e;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.25px;}.cls-128-030-4{fill:#ff6a10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-030-1",
    width: 128,
    height: 128
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-030-2",
    y: 0.04,
    width: 128,
    height: 128
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-128-030-3",
    points: "16.45 54.79 22.88 21.45 40.29 24.92 118.24 40.48 115.92 52.09"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-030-3",
    x1: 82.91,
    y1: 53.03,
    x2: 100.51,
    y2: 56.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-030-3",
    x1: 30.63,
    y1: 42.6,
    x2: 49.09,
    y2: 46.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-030-3",
    x1: 83.42,
    y1: 62.46,
    x2: 97.23,
    y2: 65.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-030-3",
    x1: 28.84,
    y1: 51.56,
    x2: 45.12,
    y2: 54.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-030-3",
    x1: 79.97,
    y1: 71.09,
    x2: 86.9,
    y2: 72.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-030-3",
    x1: 27.05,
    y1: 60.53,
    x2: 45.36,
    y2: 64.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-030-3",
    x1: 69.25,
    y1: 78.27,
    x2: 76.56,
    y2: 79.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-030-3",
    x1: 39.25,
    y1: 72.28,
    x2: 57.88,
    y2: 76
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-128-030-3",
    points: "117.99 50.98 117.99 118.64 9.76 118.64 9.76 50.98 17.18 50.98"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-030-3",
    x1: 53.07,
    y1: 82.24,
    x2: 9.76,
    y2: 50.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-030-3",
    x1: 74.68,
    y1: 82.24,
    x2: 117.99,
    y2: 50.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-030-4",
    d: "M69.53,66a3.35,3.35,0,0,1-3-3.24,6,6,0,0,1-5.3,2c-2.7-.38-3.42-2.9-3.1-5.2.47-3.39,3.44-7.58,7.74-7a11.6,11.6,0,0,1,4,1.26.79.79,0,0,1,.37,1.09L69,58.18a19.18,19.18,0,0,0-.92,3.14c-.29,2,.44,3,1.68,3.14,2.66.37,5.38-2.3,5.92-6.2.63-4.49-1.16-9.76-9.59-10.94-7.59-1.06-12.31,4.79-13.14,10.77-.79,5.62,1.21,11,9,12.13a18.58,18.58,0,0,0,3.81.12A8.12,8.12,0,0,1,67,70.25a.75.75,0,0,1,.62.91.69.69,0,0,1-.68.61,20.73,20.73,0,0,1-5.2-.06c-8.83-1.23-11.22-7.55-10.34-13.83.93-6.64,6.24-13.26,14.85-12.05,9.23,1.29,11.62,7.31,10.88,12.64C76.55,62.81,73.32,66.48,69.53,66ZM65.66,54c-3.14-.44-5.63,2.74-6,5.73-.27,2,.37,3.25,1.83,3.46,2.77.38,4.87-1.89,5.74-4.37l1.44-3.93A9.6,9.6,0,0,0,65.66,54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-030-3",
    d: "M9.76,118.64,58.18,78.83a8.94,8.94,0,0,1,11.39,0L118,118.64"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-030-3",
    x1: 18.58,
    y1: 43.72,
    x2: 9.76,
    y2: 50.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-030-3",
    d: "M101,37,69.57,11.16a9,9,0,0,0-11.39,0l-17,13.94"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-030-3",
    x1: 117.99,
    y1: 50.98,
    x2: 116.5,
    y2: 49.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-030-3",
    x1: 116.32,
    y1: 50.98,
    x2: 117.99,
    y2: 50.98
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus128030);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_128_030.94834baa43a4466a00884316713c6e93.svg";
export { ForwardRef as ReactComponent };